import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import LegacyLandingPage from "./LandingPage";
import DeviceInstallationWizard from "./DeviceInstallationWizard";
import api, { installationMessage } from "services/device-installation-service";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ClaimHead from "./claim/ClaimHead";
import { CLAIM_STAGES, claimStageCopy } from "./claim/claimTitles";

function ClaimStatus({ stage, reason, children }) {
    const { heading } = claimStageCopy(stage, { reason });
    return (
        <MDBox p={3}>
            <ClaimHead stage={stage} reason={reason} />
            <MDTypography variant="h4" component="h1" fontWeight="bold" mb={2}>
                {heading}
            </MDTypography>
            {children}
        </MDBox>
    );
}

export default function ClaimLandingRouter() {
    const { claim } = useParams();
    const [lookup, setLookup] = useState({ code: claim, routing: null, error: "" });
    useEffect(() => {
        let active = true;
        setLookup({ code: claim, routing: null, error: "" });
        api.routing(claim).then(
            (routing) => { if (active) setLookup({ code: claim, routing, error: "" }); },
            (error) => { if (active) setLookup({ code: claim, routing: null, error: installationMessage(error) }); },
        );
        return () => { active = false; };
    }, [claim]);
    if (lookup.code !== claim || (!lookup.error && !lookup.routing)) {
        return <ClaimStatus stage={CLAIM_STAGES.LOOKUP}><CircularProgress /></ClaimStatus>;
    }
    if (lookup.error) {
        return <ClaimStatus stage={CLAIM_STAGES.ERROR}><Alert severity="error">{lookup.error}</Alert></ClaimStatus>;
    }
    if (lookup.routing.flow === "device_installation") {
        // Render even if unavailable: a stored session may recover a just-completed response.
        // The wizard owns the title from here on.
        return <DeviceInstallationWizard key={claim} claimCode={claim} routing={lookup.routing} />;
    }
    if (!lookup.routing.available) {
        return (
            <ClaimStatus stage={CLAIM_STAGES.UNAVAILABLE} reason={lookup.routing.unavailable_reason}>
                <Alert severity="warning">This claim is no longer available.</Alert>
            </ClaimStatus>
        );
    }
    return <LegacyLandingPage />;
}
